const styles = theme => ({
    body: {
        padding: theme.spacing(1)
    },
    listPanel: {
        marginBottom: 150
    }
});

export default styles;